orders-warnings
  .alert.alert-warning.icons-alert(if="{opts.warnings.order_requires_approval_by_exective}")
    p
      | { this.locale().order_requires_approval_by_exective}
  .alert.alert-warning.icons-alert(if="{opts.warnings.order_requires_approval_by_sales_manager}")
    p
      | { this.locale().order_requires_approval_by_sales_manager}
  .alert.alert-warning.icons-alert(if="{opts.warnings.order_requires_approval_by_seller}")
    p
      | { this.locale().order_requires_approval_by_seller}
  script(type="typescript").
    this.mixin('base');
  style(scoped).
    p {
      margin-bottom: 0;
    }
